import React from 'react'
import './footer.scss'
import { Container, Grid, Button } from '@material-ui/core'
import FooterLogo from '../../assets/Images/Logo.png'
// import FacebookIcon from '../../assets/Images/facebook.png'
// import LinkedinIcon from '../../assets/Images/LinkedinIcon.png'
// import TwitterIcon from '../../assets/Images/twitter.png'
import LinkedInIcon from 'assets/Linkedin'
import TwitterIcon from 'assets/Twitter'
import InstagramIcon from 'assets/Instagram'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import MailchimpSubscribe from 'react-mailchimp-subscribe'
import SubscribeForm from './SubscribeForm'
const {
  REACT_APP_MAILCHIMP_API,
  REACT_APP_MAILCHIMP_U,
  REACT_APP_MAILCHIMP_NEWSLETTER_ID
} = process.env
const url = `${REACT_APP_MAILCHIMP_API}?u=${REACT_APP_MAILCHIMP_U}&id=${REACT_APP_MAILCHIMP_NEWSLETTER_ID}`

function Footer() {
  const { t } = useTranslation()
  return (
    <section className="footer">
      <div className="main_footer">
        <Container>
          <Grid style={{ justifyContent: 'center', display: 'flex' }}>
            <Grid item xl={2} lg={2} md={2} sm={3} xs={12}>
              <div className="footer_logo">
                <img src={FooterLogo} alt="logo" className="logo" />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={3} xs={12}>
              <div className="footerDetails twitter-icon-wrapper">
                <h4>{t('c.followus')}</h4>
                <div className="sociel_icons">
                  <a
                    href="https://www.linkedin.com/company/web3-domains/"
                    target="_blank"
                    style={{ marginRight: 10 }}
                  >
                    <LinkedInIcon />
                  </a>
                  <a
                    href="https://twitter.com/theweb3domains"
                    target="_blank"
                    style={{ marginRight: 10 }}
                  >
                    <TwitterIcon />
                  </a>
                  <a
                    href="https://instagram.com/theweb3domains"
                    target="_blank"
                  >
                    <InstagramIcon />
                  </a>
                </div>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={3} xs={12}>
              <div className="footerDetails">
                <h4>{t('c.links')}</h4>
                <Link to="/" className="footerlinks">
                  {t('c.domains')}
                </Link>
                <Link to="/account" className="footerlinks">
                  {t('c.account')}
                </Link>
                <Link to="/learn" className="footerlinks">
                  {t('c.learn')}
                </Link>
                <Link to="/faq" className="footerlinks">
                  {t('c.faq')}
                </Link>
                <Link to="/contact" className="footerlinks">
                  {t('c.contact')}
                </Link>
                <Link to="/affliate" className="footerlinks">
                  {t('c.affliate')}
                </Link>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={3} xs={12}>
              <div className="footerDetails">
                <h4>{t('c.contact')}</h4>
                <p>W3D.AVAX</p>
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={4} xs={12} className="footerform">
              <MailchimpSubscribe
                url={url}
                render={({ subscribe, status, message }) => (
                  <SubscribeForm
                    status={status}
                    message={message}
                    onValidated={subscribe}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className="copyright">
        <div className="copyright_left">
          <Link
            to="/privacy-and-policy"
            style={{
              color: 'inherit'
            }}
          >
            Privacy & Policy{' '}
          </Link>{' '}
          <Link
            to="/terms-of-use"
            style={{
              color: 'inherit'
            }}
          >
            Terms of Use
          </Link>
          <a
            href="https://strapi.testnet.5ire.network/uploads/AVAX_73795be084.pdf"
            target="_blank"
            style={{
              color: 'inherit'
            }}
          >
            Service Guide
          </a>
          <a
            href="https://strapi.testnet.5ire.network/uploads/Domain_Naming_Service_DNS_docx_1_5e33de9563.pdf"
            target="_blank"
            style={{
              color: 'inherit'
            }}
          >
            Whitepaper
          </a>
        </div>
        <span>© 2022 .BNB DOMAINS. All rights reserved.</span>
      </div>
    </section>
  )
}

export default Footer
